import { ClinicConfig } from "fe-common/graphql/clinic/clinicTypes";
import { ClinicConfigKeys } from "fe-common/graphql/clinic/clinicConfigKeys";
import { ThemeSettings } from "@kahunmedical/common-configuration";

export const OldClinicEntryToNewSettingsCategory = {
  [ClinicConfigKeys.SolverFeatureFlags]: "conversation",
  [ClinicConfigKeys.FeatureFlags]: "fe",
  [ClinicConfigKeys.Backoffice]: "backoffice",
  [ClinicConfigKeys.General]: "clinic",
  [ClinicConfigKeys.Theme]: "theme",
  [ClinicConfigKeys.ExternFeatureIdsMapping]: null,
  [ClinicConfigKeys.Translations]: null,
};

function removeBooleanStrings(value: any) {
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
}

export const migrateClinicSettingsToV2 = (config: ClinicConfig) => {
  return !config || typeof config !== "object"
    ? null
    : Object.entries(config).reduce((acc, [oldSettingsKey, value]) => {
        if (oldSettingsKey === ClinicConfigKeys.SolverFeatureFlags) {
          return {
            ...acc,
            ...oldClinicSolverFlagsToNewSettingsObject(config[oldSettingsKey]),
          };
        }
        if (oldSettingsKey === ClinicConfigKeys.Theme) {
          return {
            ...acc,
            ...oldClinicThemeToNewSettingsObject(config[oldSettingsKey]),
          };
        }
        return {
          ...acc,
          ...oldClinicSettingToNewSettingsObject(
            config[oldSettingsKey],
            OldClinicEntryToNewSettingsCategory[oldSettingsKey],
          ),
        };
      }, {});
};

function oldClinicSolverFlagsToNewSettingsObject(
  solverFeatureFlags: Record<string, any>,
): object {
  return Object.entries(solverFeatureFlags).reduce((acc, [oldKey, value]) => {
    if (oldKey.includes("PathOptions_")) {
      return {
        ...acc,
        [oldKey.replace("PathOptions_", "agentDD.")]: value,
      };
    }
    if (oldKey.includes("ConversationOptions_")) {
      // Summary options used to be an object with settings
      // so we need to flatten it in the new settings structure
      if (oldKey === "ConversationOptions_summaryOptions") {
        //ConversationOptions_summaryOptions: { discardNoForNegate: false, heightInInches: true, showAssessment: true, weightInPounds: true }
        return Object.entries(value).reduce(
          (summaryOpAcc, [summaryOpKey, summaryOpValue]) => {
            return {
              ...summaryOpAcc,
              [`conversation.summaryOptions.${summaryOpKey}`]: summaryOpValue,
            };
          },
          acc,
        );
      }
      return {
        ...acc,
        [oldKey.replace("ConversationOptions_", "conversation.")]: value,
      };
    }
    return {};
  }, {});
}

function oldClinicThemeToNewSettingsObject(theme: ThemeSettings): object {
  return Object.entries(theme).reduce((acc, [oldKey, value]) => {
    if (oldKey.includes("colors")) {
      return Object.entries(value).reduce(
        (colorAcc, [colorKey, colorValue]) => ({
          ...colorAcc,
          [`${
            OldClinicEntryToNewSettingsCategory[ClinicConfigKeys.Theme]
          }.colors.${colorKey}`]: colorValue,
        }),
        acc,
      );
    }
    return {
      ...acc,
      [`${
        OldClinicEntryToNewSettingsCategory[ClinicConfigKeys.Theme]
      }.${oldKey}`]:
        value === "true" ? true : value === "false" ? false : value, // Make sure to remove boolean strings
    };
  }, {});
}

function oldClinicSettingToNewSettingsObject(
  oldSettingsObject: object,
  newEntry: string,
): object {
  // if there is no new mapping skip this entry
  if (!newEntry || !oldSettingsObject) return {};
  return Object.entries(oldSettingsObject).reduce((acc, [oldKey, value]) => {
    return { ...acc, [`${newEntry}.${oldKey}`]: removeBooleanStrings(value) };
  }, {});
}
